import { render, staticRenderFns } from "./ant-s.vue?vue&type=template&id=0cd98e98&scoped=true"
import script from "./ant-s.vue?vue&type=script&lang=js"
export * from "./ant-s.vue?vue&type=script&lang=js"
import style0 from "./ant-s.vue?vue&type=style&index=0&id=0cd98e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd98e98",
  null
  
)

export default component.exports